module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.bdadb512.woff";